import React, { FC, useEffect, useState } from 'react';
import { MANIFEST_STATUS, TripManifest } from '../../../redux/api/manifest/manifest.model';
import { ReactComponent as Error } from '../../../assets/icons/error.svg';
import TwTooltip from '../../TwTooltip/TwTooltip';
import Box from '@mui/material/Box';

interface TwManifestErrorTooltipProps {
  manifest: TripManifest;
}

export const TwManifestErrorTooltip: FC<TwManifestErrorTooltipProps> = ({ manifest }) => {
  const [tooltip, setTooltip] = useState<string>('');
  useEffect(() => {
    if (!manifest.errors.notes) return;
    const errors = manifest.errors.notes.map((n: string) => '- ' + n).join('\n');
    setTooltip(errors);
  }, [JSON.stringify(manifest)]);

  const getReadableStatus = (status: string): string => {
    return status[0].toUpperCase() + status.slice(1).toLowerCase();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        ...(manifest.status === MANIFEST_STATUS.REJECTED && { color: '#DC2626' })
      }}
    >
      {getReadableStatus(manifest.status)}
      {manifest.status === MANIFEST_STATUS.REJECTED && (
        <TwTooltip
          title={tooltip}
          placement="top"
          sx={{ whiteSpace: 'pre-wrap', maxWidth: '200px', maxHeight: '500px', overflowY: 'auto' }}
        >
          <Error />
        </TwTooltip>
      )}
    </Box>
  );
};
